import React, { useContext, useEffect, useState } from 'react'
import Logo from '../../assets/images/svbk_logo.png'
import { IoLogOutOutline } from "react-icons/io5"; //added by ashok
import NewLogo from "../../assets/images/svbk_logo1.png";//added by ashok
import "./Header.css"
import { useNavigate } from 'react-router-dom';
import AppContext from '../../storage/AppContext';
import { clearStorage } from '../../storage/storage';
import { changeStatus } from '../../redux/features/login/loginSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getAcademicYears, getStudentsDetailsByBranch, getUserNotifications, resetAllState } from '../../redux/features/student/studentSlice';
import {FiBell} from "react-icons/fi"

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { getRejectedTemplates, getTemplates } from '../../redux/features/template/templateSlice';

const RenderLinks = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const userDetails = appContext?.userDetails;

  const onLogout = () => {
    clearStorage();
    dispatch(changeStatus());
    dispatch(resetAllState());
    appContext.setUserDetails(null);
    navigate("/");
  };

  return (
    <Nav className="w-100 p-3 p-lg-0 d-flex flex-column align-items-stretch flex-lg-row align-items-lg-center">
       <Nav.Link
        className="navbar-navigation-button-link"
        onClick={() => {
          navigate("/templates");
          dispatch(resetAllState());
        }}
      >
        Templates
      </Nav.Link>

      {userDetails?.data?.role === "Admin" && 
      <Nav.Link
        className="navbar-navigation-button-link"
        onClick={() => {
          navigate("/saveMedia");
          dispatch(resetAllState());
        }}
      >
       Save Media
      </Nav.Link>}

      <Nav.Link
        className="navbar-navigation-button-link"
        onClick={() => {
          navigate("/viewMedia");
          dispatch(resetAllState());
        }}
      >
       View Media
      </Nav.Link>
      
      {userDetails?.data?.role === "Admin" && 
      <Nav.Link
        className="navbar-navigation-button-link"
        onClick={() => {
          navigate("/announcements");
          dispatch(resetAllState());
        }}
      >
        Announcements
      </Nav.Link>}

      {userDetails?.data?.role === "Admin" && 
      <Nav.Link
        className="navbar-navigation-button-link"
        onClick={() => {
          navigate("/uploadStudentDetails");
          dispatch(resetAllState());
        }}
      >
        Upload
      </Nav.Link>}

      <Nav.Link
        className="navbar-navigation-button-link"
        onClick={() => {
          navigate("/viewStudentDetails");
          dispatch(resetAllState());
          dispatch(
            getStudentsDetailsByBranch({
              branch: userDetails?.data?.branch,
            })
          );
          dispatch(getAcademicYears());
        }}
      >
        View
      </Nav.Link>
      <Nav.Link
        className="navbar-navigation-button-link"
        onClick={() => {
          navigate("/admission");
          dispatch(resetAllState());
        }}
      >
        Pay Now
      </Nav.Link>
      <Nav.Link
        className="navbar-navigation-button-link logout-bt ml-lg-2"
        onClick={() => onLogout()}
      >
        <IoLogOutOutline
          title='Logout'
          size={40}
          color="#42413e"
          className="d-none d-lg-inline"
        />
        <span className="d-lg-none">Logout</span>
      </Nav.Link>
    </Nav>
  );
};

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);

  const userDetails = appContext?.userDetails;
  const notifications = useSelector((state) => state.student.notificationDetails.notifications);

  useEffect(() => {
    const branch = userDetails?.data?.branch;
    const role = userDetails?.data?.role;
    dispatch(getUserNotifications({ branch, role }));
    dispatch(getTemplates({branch}))
    dispatch(getRejectedTemplates({branch}))
  }, []);

  return (
    <>
      <Navbar
        className="p-0"
        collapseOnSelect
        expand="lg"
        bg="light"
        variant="light"
      >
        <Container fluid className="d-flex align-items-stretch flex-column">
          <div className="d-flex justify-content-between align-items-center pr-3 pr-lg-0">
            <Navbar.Brand className="navbar-logo-container">
              <img className="w-100 h-100" src="https://aautifileuploads.blob.core.windows.net/svbk/svbk_receipt_logo.png" alt="SVBK-logo" />
            </Navbar.Brand>
            <Navbar.Brand className='navbar-welcome-text'>
              Welcome {userDetails?.data?.role}
            </Navbar.Brand>

            <div className="d-flex align-items-center">
              <Navbar.Brand>
                <div className="d-flex align-items-center">
                  <FiBell
                    title='Notifications'
                    size={27}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigate("/notifications");
                    }}
                  />
                  <span
                    style={{
                      color: "#F77777",
                      fontWeight: "500",
                      fontSize: "16px",
                      marginLeft: "-5px",
                      marginBottom: "20px",
                    }}
                  >
                    {notifications.length}
                  </span>
                </div>
              </Navbar.Brand>
              <div className="d-none d-lg-block">
                <RenderLinks />
              </div>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            </div>
          </div>
          <div className="d-lg-none">
            <Navbar.Collapse id="responsive-navbar-nav">
              <RenderLinks />
            </Navbar.Collapse>
          </div>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
